'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
require('../browser-05a2bba8.js');
require('../_commonjsHelpers-3fc1f64e.js');
require('../_react_commonjs-external-30e5c7b3.js');
require('../style-222d2b0f.js');
var s18 = require('../typography/s18.js');
require('../index-db6682ea.js');
var text = require('./text.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  margin: ", ";\n  a {\n    word-wrap: break-word;\n  }\n"], ["\n  margin: ", ";\n  a {\n    word-wrap: break-word;\n  }\n"]);
var StyledTermSection = styled__default.div(_templateObject, function (props) {
  return props.margin ? props.margin : "0 0 20px 0";
});

var TermSection = function TermSection(_ref) {
  var title = _ref.title,
      terms = _ref.terms,
      titleMargin = _ref.titleMargin,
      titleSize = _ref.titleSize,
      termsMargin = _ref.termsMargin,
      termsAlign = _ref.termsAlign,
      termsSize = _ref.termsSize;
  return React__default.createElement(
    StyledTermSection,
    null,
    title && React__default.createElement(
      s18.default,
      { margin: titleMargin, size: titleSize },
      title
    ),
    terms && React__default.createElement(text, {
      textAlign: termsAlign,
      size: termsSize,
      terms: terms,
      margin: termsMargin
    })
  );
};

TermSection.propTypes = {
  /** text to display as a title on top of panel */
  title: PropTypes$1.string,
  /** margin for section title */
  titleMargin: PropTypes$1.string,
  /** size of title */
  titleSize: PropTypes$1.string,
  /** margin for section term  */
  termsMargin: PropTypes$1.string,
  /** font size for section term  */
  termsSize: PropTypes$1.string,
  /** margin for section term  */
  termsAlign: PropTypes$1.string,
  /** list of text to display in the panel */
  terms: PropTypes$1.arrayOf(PropTypes$1.shape({ text: PropTypes$1.string }))
};

TermSection.defaultProps = {
  titleMargin: "0 0 0 0"
};
TermSection.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TermSection",
  "props": {
    "titleMargin": {
      "defaultValue": {
        "value": "\"0 0 0 0\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "margin for section title"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text to display as a title on top of panel"
    },
    "titleSize": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "size of title"
    },
    "termsMargin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "margin for section term"
    },
    "termsSize": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "font size for section term"
    },
    "termsAlign": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "margin for section term"
    },
    "terms": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "text": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "list of text to display in the panel"
    }
  }
};

module.exports = TermSection;
//# sourceMappingURL=section.js.map
